<template>
  <div class="nweaddcheck2">
    <m-title></m-title>
    <div class="planlobby_content" style="overflow-y: scroll;">
      <div class="top_content">
        <div class="item">
          <span>计划单号</span>
          <div class="inpstyNew">{{ dispatchTruck.pno | formatMsgFun }}</div>
        </div>
        <div class="item">
          <span>车牌号</span>
          <div class="inpstyNew">{{ dispatchTruck.plate | formatMsgFun }}</div>
        </div>
        <div class="item">
          <span>货场名称</span>
          <div class="inpstyNew">
            {{ dispatchTruck.storename | formatMsgFun }}
          </div>
        </div>
        <div class="item">
          <span>货主名称</span>
          <div class="inpstyNew">
            {{ dispatchTruck.customname | formatMsgFun }}
          </div>
        </div>
        <div class="item">
          <span>代理名称</span>
          <div class="inpstyNew">
            {{ dispatchTruck.agentname | formatMsgFun }}
          </div>
        </div>
        <div class="item">
          <span>流向</span>
          <div class="inpstyNew">
            {{ dispatchTruck.custmername | formatMsgFun }}
          </div>
        </div>
        <div class="item">
          <span>代理名称</span>
          <div class="inpstyNew">
            {{ dispatchTruck.fleetname | formatMsgFun }}
          </div>
        </div>
        <div class="item">
          <span>计划吨数</span>
          <div class="inpstyNew">{{ planEntity.plantons  || "" }}</div>
        </div>
        <div class="item" v-if="dispatchTruck.teasonForCancellation">
          <span>备注</span>
          <div class="inpstyNew">{{ dispatchTruck.teasonForCancellation }}</div>
        </div>
      </div>
      <div class="card">
        <div class="planlobby_content2">
          <!-- 备注图片 -->
          <div class="bottextarea" v-if="dispatchTruck.uploadImage">
            <span class="imginfo">备注图片</span>
            <el-image
              lazy
              style="width: 100%; height: 100%"
              :src="dispatchTruck.uploadImage"
              :preview-src-list="[dispatchTruck.uploadImage]"
            >
            </el-image>
          </div>
          <!-- 健康码 -->
          <div class="bottextarea" v-if="dispatchTruck.healthCode">
            <span class="imginfo">健康码</span>
            <el-image
              lazy
              style="width: 100%; height: 100%"
              :src="dispatchTruck.healthCode"
              :preview-src-list="[dispatchTruck.healthCode]"
            >
            </el-image>
          </div>
          <!-- 行程码 -->
           <div class="bottextarea" v-if="dispatchTruck.itineraryCode">
            <span class="imginfo">行程码</span>
            <el-image
              lazy
              style="width: 100%; height: 100%"
              :src="dispatchTruck.itineraryCode"
              :preview-src-list="[dispatchTruck.itineraryCode]"
            >
            </el-image>
          </div>
          <!-- 核酸证明 -->
         <div class="bottextarea" v-if="dispatchTruck.nucleicAcidCode">
            <span class="imginfo">核酸证明</span>
            <el-image
              lazy
              style="width: 100%; height: 100%"
              :src="dispatchTruck.nucleicAcidCode"
              :preview-src-list="[dispatchTruck.nucleicAcidCode]"
            >
            </el-image>
          </div>
		  
		  <div class="bottextarea" v-if="dispatchTruck.arrivingCheckUrl">
		     <span class="imginfo">落地核酸检测</span>
		     <el-image
		       lazy
		       style="width: 100%; height: 100%"
		       :src="dispatchTruck.arrivingCheckUrl"
		       :preview-src-list="[dispatchTruck.arrivingCheckUrl]"
		     >
		     </el-image>
		   </div>
        </div>
      </div>
      <div class="bottom_div">
        <div
          class="botton_btn"
          style="color: #17B6A1; background: #f3f4f5"
          @click="returnpage"
        >
          返回
        </div>
        <div class="botton_btn" @click="approved(true)">审核通过</div>
        <div
          class="botton_btn"
          style="background: #ff5926"
          v-if="navigationMsgGt[1].name != '线下取消'"
          @click="approved(false)"
        >
          审核不通过
        </div>
      </div>
	  <p style="margin-left: 10px;font-weight: bold;">
	  	随车人员列表：
	  </p>
	  <el-table :data="arrlist.list" border  style="margin-left: 10px; width: 98%;height: 200px; " >
	     <el-table-column show-overflow-tooltip :render-header="renderHeader"
	      label="序号"
	      type="index"
	      width="50px"
	    ></el-table-column>
	    <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="driver_name" label="姓名"></el-table-column>
	    <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="driver_creticard" label="身份证号"></el-table-column>
	    <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="telephone" label="手机号"></el-table-column>
	    <el-table-column show-overflow-tooltip :render-header="renderHeader" label="防疫上传时间">
	      <template v-slot="res">
	        <span>{{ mydateFormat(res.row.fytime, "时分秒") }}</span>
	      </template>
	    </el-table-column>
	    <el-table-column show-overflow-tooltip :render-header="renderHeader" label="七日内是否离津">
	      <template v-slot="res">
	        <span
	          style="color: #ef6b60"
	          class="el_spanfontstyle"
	          v-if="res.row.leave_tianjin == 0"
	          >是</span
	        >
	        <span
	          style="color: #448aff"
	          class="el_spanfontstyle"
	          v-if="res.row.leave_tianjin == 1"
	          >否</span
	        >
	      </template>
	    </el-table-column>
	     <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="tu_jing" label="七日途经地"></el-table-column>
	     <el-table-column show-overflow-tooltip :render-header="renderHeader" label="健康码是否为绿码">
	       <template v-slot="res">
	         <span
	           style="color: #ef6b60"
	           class="el_spanfontstyle">是</span
	         >
	       </template>
	     </el-table-column>
	    <el-table-column show-overflow-tooltip :render-header="renderHeader" label="体温是否正常">
	      <template v-slot="res">
	        <span
	          style="color: #ef6b60"
	          class="el_spanfontstyle"
	          v-if="res.row.body_temperature == 0"
	          >正常</span
	        >
	        <span
	          style="color: #448aff"
	          class="el_spanfontstyle"
	          v-if="res.row.body_temperature == 1"
	          >否</span
	        >
	      </template>
	    </el-table-column>
	    <el-table-column show-overflow-tooltip :render-header="renderHeader" label="是否落地检">
	      <template v-slot="res">
	        <span
	          style="color: #ef6b60"
	          class="el_spanfontstyle"
	          v-if="res.row.arriving_check == 0"
	          >是</span
	        >
	        <span
	          style="color: #448aff"
	          class="el_spanfontstyle"
	          v-if="res.row.arriving_check == 1"
	          >否</span
	        >
	      </template>
	    </el-table-column>
	    <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="arriving_check_place" label="检查地点"></el-table-column>
	    <el-table-column show-overflow-tooltip :render-header="renderHeader" label="检查时间">
	      <template v-slot="res">
	        <span>{{ mydateFormat(res.row.arriving_check_time, "时分秒") }}</span>
	      </template>
	    </el-table-column>
	    
	    <el-table-column show-overflow-tooltip :render-header="renderHeader" label="是否有48小时核酸阴性证明">
	      <template v-slot="res">
	        <span
	          style="color: #ef6b60"
	          class="el_spanfontstyle"
	          v-if="res.row.report48_hours == 0"
	          >是</span
	        >
	        <span
	          style="color: #448aff"
	          class="el_spanfontstyle"
	          v-if="res.row.report48_hours == 1"
	          >否</span
	        >
	      </template>
	    </el-table-column>
	  </el-table>
	  
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import mSuperIpt from "@/components/mSuperIpt.vue";
import { mapGetters } from "vuex";
export default {
  name:"infomsg",
  data() {
    return {
      dispatchTruck: {},
      planEntity: {},
	  arrlist: { list: [] },
	  conditionssx: {
	  	page: 1,
	  	limit: 20,
	  	peopleType: "1",
	  	id: this.$route.params.id
	  }
    };
  },
  computed: {
    ...mapGetters(["navigationMsgGt"]),
  },
  components: {
    mTitle,
    mSuperIpt,
  },
  created() {
    this.getiteminfo();
	this.getjobdetails();
  },
  methods: {
	  async getjobdetails() {
	    const { data } = await this.$http(
	      "api1",
	      "/driver/epidemicprevention/getEpidemicPrevention",
	      "get",
	      this.conditionssx
	    );
	    if (data.code != 0) return this.$message.error(data.msg);
	    this.arrlist = data.data;
	  },
    async getiteminfo() {
      const { data } = await this.$http(
        "api1",
        "/driver/dispatchtruck/dispatchTruckinfoById",
        "post",
        { id: this.$route.params.id }
      );
      if (data.code != 0) return console.log("infomsg获取详情失败");
      this.carEntity = data.carEntity;
      this.dispatchTruck = data.dispatchTruck;
      this.planEntity = data.planEntity;
    },
    approved(info) {
      var path = "",
        title = "",
        successifo = "";
      if (info) {
        switch (this.navigationMsgGt[1].path) {
          case "/audit/auditcar":
            path = "/driver/dispatchtruck/approveSendSomeonePlan";
            break;
          case "/audit/entercancel":
            path = "/driver/dispatchtruck/dispatchCancelAfterEnteringPassed";
            break;
          case "/audit/awaitaudit":
            path = "/driver/dispatchtruck/offlinePaymentPassTheAudit";
            break;
          case "/audit/offlinetocancel":
            path = "/driver/dispatchtruck/offlinePaymentCancelDispatch";
            break;
        }
        title = "选中的数据将通过审核";
        successifo = "审核已通过";
      } else {
        switch (this.navigationMsgGt[1].path) {
          case "/audit/auditcar":
            path = "/driver/dispatchtruck/FailedAuditSendSomeonePlan";
            break;
          case "/audit/entercancel":
            path = "/driver/dispatchtruck/dispatchCancelAfterEnteringNotPassed";
            break;
          case "/audit/awaitaudit":
            path = "/driver/dispatchtruck/offlinePaymentDidNotPassTheAudit";
            break;
          case "/audit/offlinetocancel":
            path = "";
            break;
        }
        title = "选中的数据将审核不通过";
        successifo = "操作成功";
      }
      if (!path) return "";
      this.$messageBox
        .confirm(`${title}, 是否继续?`, `${this.dispatchTruck.plate}`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          const { data } = await this.$http("api1", path, "post", {
            ids: [this.$route.params.id],
          });
          if (data.code == 500) return this.$message.error(data.msg);
          this.$message.success(successifo);
          this.returnpage();
        })
        .catch((err) => err);
    },
    returnpage() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.nweaddcheck2 {
  position: relative;
  height: 100%;
  .planlobby_content {
    position: absolute;
    top: 50px;
    bottom: 0;
    width: 100%;
    background: #fff;
    .top_content {
      position: relative;
      height: 50%;
      padding-top: 2%;
      box-sizing: border-box;
      .item {
        margin: 0 auto;
        width: 32%;
        height: 11%;
        text-align: right;
        font-size: 80%;
        &::before {
          display: inline-block;
          content: "";
          height: 65%;
          vertical-align: middle;
        }
        .input,
        .inpstyNew {
          float: right;
          width: 72%;
          height: 65%;
          margin-left: 5%;
          text-align: left;
          background: #f3f4f5;
          border-radius: 2px;
        }
        .inpstyNew {
          color: #666666;
          background: transparent;
        }
        .inpstyNew::before {
          content: "";
          display: inline-block;
          height: 100%;
          vertical-align: middle;
        }
      }
    }
    .card {
      box-sizing: border-box;
      height: 30%;
      .planlobby_content2 {
        height: 100%;
        width: 100%;
        padding-top: 10px;
        margin: 0 auto;
        text-align: center;
        box-sizing: border-box;
        .bottextarea {
          position: relative;
          display: inline-block;
          box-sizing: border-box;
          height: 90%;
          width: 24%;
          margin-right: 1%;
          background: #f3f4f5;
          background-size: 100% 100%;
          &:last-of-type {
            margin: 0;
          }
          .imginfo{
            position: absolute;
            z-index: 999;
            top: -15px;
            left: 50%;
            font-size: 13px;
            transform: translateX(-50%);
          }
        }
      }
    }
    .bottom_div {
      position: relative;
      margin: 30px auto;
      width: 300px;
      overflow: hidden;
      .botton_btn {
        display: inline-block;
        cursor: pointer;
        width: 80px;
        margin: 0 10px;
        line-height: 38px;
        text-align: center;
        border-radius: 5px;
        color: #fff;
        font-size: 13px;
        background: #17B6A1;
      }
    }
  }
}
</style>